import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import loadTraits from './traits';
import { colFormRef } from './consts';

export default grapesjs.plugins.add('gjs-search-form', (editor, opts) => {
  let c = opts || {};

  let defaults = {
    pfx: 'search-form',
    blocks: [colFormRef],
    defaultStyle: true,
    labelColForm: 'Data Search Form',
    labelColFormCategory: 'CMS',
    labelColName: 'Search',
  };

  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }

  loadComponents(editor, c);
  loadBlocks(editor, c);
  loadTraits(editor, c);
});
